import {
  Stack,
  TextField,
  useTheme,
  Button,
  Container,
  Typography,
  Paper,
  Grid,
  Dialog,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  IconButton,
  DialogTitle,
  DialogActions,
  Snackbar,
  Alert,
  Autocomplete,
  LinearProgress,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Chip,
} from '@mui/material';
import Slide from '@mui/material/Slide';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Checkbox from '@mui/material/Checkbox';

import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState, useCallback } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import styled from '@emotion/styled';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import GridOnIcon from '@mui/icons-material/GridOn';
import XLSXS from 'xlsx-js-style';
import moment from 'moment';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import axios from '../../axiosConfig';
import './animation.css';


// table header cell styles
const StyledTableCell = styled(TableCell)({
  color: '#424242',
  fontWeight: '600',
});

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const UserMst = () => {
  const tokent =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [open, setOpen] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [openAlert, setopenAlert] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [operation, setOperation] = useState('Add');
  // alert messages on operations
  const [alertType, setAlertType] = useState('success'); // 'success' or 'error'
  const [alertMessage, setAlertMessage] = useState('');

  const [errors, setErrors] = useState({
    UserCode: false,
    UserName: false,
    Email: false,
    PhoneNumber: false,
    Grade: false,
    Line: false,
    Salary: false,
    UserPassword: false,
    DepartmentId: false,
    DesignationId: false,
    gender: false,
    logSelected: false,
    unitlogSelected: false,
    linelogSelected: false,
    processlogSelected: false,
    ActiveStatus: false,
    UserTypeId: false,
  });

  const [helperTexts, setHelperTexts] = useState({
    UserCode: '',
    UserName: '',
    Email: '',
    PhoneNumber: '',
    Grade: '',
    Line: '',
    Salary: '',
    UserPassword: '',
    DepartmentId: '',
    DesignationId: '',
    gender: '',
    loginAccess: '',
    ActiveStatus: '',
    logSelected: '',
    unitlogSelected: '',
    linelogSelected: '',
    processlogSelected: '',
    UserTypeId: '',
  });

  // input fields state values
  const [UserCode, setUserCode] = useState('');
  const [UserName, setUserName] = useState('');
  const [Email, setEmail] = useState('');
  const [PhoneNumber, setPhoneNumber] = useState('');
  const [Grade, setGrade] = useState('');
  const [Salary, setSalary] = useState('');
  const [UserPassword, setUserPassword] = useState('');
  const [deptData, setDeptData] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [designData, setDesignData] = useState([]);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState(null);
  const [selectedDesignationId, setSelectedDesignationId] = useState(null);
  const [gender, setGender] = useState('M');
  const [loginAccess, setLoginAccess] = useState('N');
  const [ActiveStatus, setActiveStatus] = useState('Y');
  const [usersData, setusersData] = useState([]);
  const [logData, setLogData] = useState([]);
  const [IdToDelete, setIdToDelete] = useState(null);
  const [editID, setEditID] = useState();
  const [openLoader, setOpenLoader] = useState(false);
  const [userTypeFilter, setUserTypeFilter] = useState('Employee');
  const [lineLogData, setLineLogData] = useState([]);
  const [unitLogData, setUnitLogData] = useState([]);
  const [lineData, setLineData] = useState([]);
  const [unitData, setUnitData] = useState([]);
  const [selectedUserTypeId, setSelectedUserTypeId] = useState(null);
  const [selectedGradeValue, setSelectedGradeValue] = useState(null);
  const [gradeData, setGradeData] = useState([]);
  const [LineMstData, setLineMstData] = useState([]);
  const [selectedLineValue, setSelectedLineValue] = useState(null);
  const [ProcessMstData, setProcessMstData] = useState([]);
  const [processLogData, setProcessLogData] = useState([]);
  const [IsContractEmp, setIsContractEmp] = useState(false);

  // API Integration
  useEffect(() => {
    getUsers('N');
    GetAllActiveCompany();
    GetAllDepartmentMstData();
    GetAllDesignationMstData();
    GetLineMstData();
    GetGradeMstData();
    getAllProcessData();
  }, []);

  const userTypeData = [
    { UserType: 'Admin', UserTypeId: 'Admin' },
    { UserType: 'Supervisor', UserTypeId: 'Supervisor' },
    { UserType: 'IE', UserTypeId: 'IE' },
    { UserType: 'Line Writer', UserTypeId: 'Line Writer' },
  ];

  // const gradeData = [
  //   { GradeLable: 'A', GradeValue: 'A' },
  //   { GradeLable: 'B', GradeValue: 'B' },
  //   { GradeLable: 'C', GradeValue: 'C' },
  //   { GradeLable: 'D', GradeValue: 'D' },
  //   { GradeLable: 'N/A', GradeValue: '' },
  // ];

  const GetLineMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllLineMstData`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setLineMstData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const GetGradeMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllGradeMstData`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setGradeData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const getAllProcessData = async (processId = 0) => {
    try {
      const res = await axios.instance.get(`/GetAllProcessData/${processId}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setProcessMstData(res.data);
      return res.data;
    } catch (error) {
      console.error('Error fetching process data:', error);
      return [];
    }
  };

  // get all op group Request
  const GetAllActiveCompany = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveCompany', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setCompanyData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all op group Request
  const GetAllDepartmentMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllDepartmentMstData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setDeptData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all machine date
  const GetAllDesignationMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllDesignationMstData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setDesignData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const downloadPDF = async () => {
    setOpenLoader(true);
    try {
      const type = userTypeFilter === 'Employee' ? 'N' : 'Y';
      const res = await axios.instance.get(`/GetAllUserspdf/${type}`, {
        responseType: 'blob',
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'EmployeeList.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error downloading PDF:', error);
      setOpenLoader(false);
    }
  };

  const downloadExcel = () => {
    if (filteredData.length === 0) return;

    const wb = XLSXS.utils.book_new();
    const isUser = userTypeFilter === 'User';
    const title = isUser ? 'Users List' : 'Employees List';

    const headers = [
      'S.No', 'Employee Code', 'Name', 'Gender', 'Email', 'Phone',
      'Department', 'Designation', 'Grade', 'Salary', 'Line'
    ];

    const data = filteredData.map((user, index) => {
      const row = {
        'S.No': index + 1,
        'Employee Code': user.UserCode || '',
        'Name': user.Users || '',
        'Gender': user.Gender === 'M' ? 'Male' : (user.Gender === 'F' ? 'Female' : ''),
        'Email': user.Email || '',
        'Phone': user.PhoneNumber || '',
        'Department': user.DepartmentDescription || '',
        'Designation': user.DesignationDescription || '',
        'Grade': user.GradeName || '',
        'Salary': user.Salary ? Number(user.Salary) : 0,
        'Line': user.LineName || '',
      };
      return row;
    });

    const startRow = 4;
    const ws = XLSXS.utils.json_to_sheet(data, { origin: `A${startRow}`, header: headers });

    // Title row
    ws.A1 = {
      v: title,
      t: 's',
      s: {
        font: { bold: true, sz: 16, color: { rgb: 'FFFFFF' } },
        alignment: { horizontal: 'center', vertical: 'center' },
        fill: { fgColor: { rgb: '2596BE' } },
      },
    };

    // Generated date
    ws.A2 = {
      v: `Generated on: ${moment().format('DD-MM-YYYY HH:mm:ss')}`,
      t: 's',
      s: {
        font: { sz: 10, color: { rgb: '666666' } },
        alignment: { horizontal: 'right' },
      },
    };

    const lastColIndex = headers.length - 1;
    const lastColLetter = String.fromCharCode(65 + Math.min(lastColIndex, 25));

    // Merge title row
    ws['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: lastColIndex } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: lastColIndex } },
    ];

    // Style header row
    const headerRowIndex = startRow - 1;
    headers.forEach((header, colIdx) => {
      const cellRef = XLSXS.utils.encode_cell({ r: headerRowIndex, c: colIdx });
      if (ws[cellRef]) {
        ws[cellRef].s = {
          font: { bold: true, sz: 10, color: { rgb: 'FFFFFF' } },
          fill: { fgColor: { rgb: '6EACDA' } },
          alignment: { horizontal: 'center', vertical: 'center' },
          border: {
            top: { style: 'thin', color: { rgb: 'E0E0E0' } },
            bottom: { style: 'thin', color: { rgb: 'E0E0E0' } },
            left: { style: 'thin', color: { rgb: 'E0E0E0' } },
            right: { style: 'thin', color: { rgb: 'E0E0E0' } },
          },
        };
      }
    });

    // Style data rows
    data.forEach((row, rowIdx) => {
      const excelRow = startRow + rowIdx;
      headers.forEach((header, colIdx) => {
        const cellRef = XLSXS.utils.encode_cell({ r: excelRow, c: colIdx });
        if (ws[cellRef]) {
          const isEvenRow = rowIdx % 2 === 0;
          const statusVal = ws[cellRef].v;
          let fontColor = '000000';
          let bgColor = isEvenRow ? 'FFFFFF' : 'F9F9F9';

          if (header === 'Status') {
            fontColor = statusVal === 'Active' ? '008000' : 'FF0000';
            bgColor = statusVal === 'Active' ? 'E8F5E8' : 'FFE8E8';
          }

          ws[cellRef].s = {
            font: {
              sz: 10,
              color: { rgb: fontColor },
              ...(header === 'Salary' ? { name: 'Courier New' } : {}),
              ...(header === 'Status' || header === 'Salary' ? { bold: true } : {}),
            },
            fill: { fgColor: { rgb: bgColor } },
            alignment: {
              horizontal: header === 'S.No' || header === 'Grade' || header === 'Status' ? 'center'
                : header === 'Salary' ? 'right' : 'left',
            },
            border: {
              top: { style: 'thin', color: { rgb: 'E0E0E0' } },
              bottom: { style: 'thin', color: { rgb: 'E0E0E0' } },
              left: { style: 'thin', color: { rgb: 'E0E0E0' } },
              right: { style: 'thin', color: { rgb: 'E0E0E0' } },
            },
          };
        }
      });
    });

    // Column widths
    ws['!cols'] = [
      { wch: 6 },   // S.No
      { wch: 14 },  // Employee Code
      { wch: 22 },  // Name
      { wch: 8 },   // Gender
      { wch: 22 },  // Email
      { wch: 14 },  // Phone
      { wch: 16 },  // Department
      { wch: 18 },  // Designation
      { wch: 8 },   // Grade
      { wch: 12 },  // Salary
      { wch: 12 },  // Line
    ];

    ws['!ref'] = `A1:${lastColLetter}${startRow + data.length}`;

    XLSXS.utils.book_append_sheet(wb, ws, title);
    XLSXS.writeFile(wb, `${title.replace(/ /g, '_')}_${moment().format('DD-MM-YYYY')}.xlsx`);
  };

  // get all Users Request
  const getUsers = async (type) => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllUsers/${type}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setusersData(res.data);
      setOpenLoader(false);
      setLoginAccess(type);
      // console.log('users', res.data);
    } catch (error) {
      console.error('Error fetching courses:', error);
    }
  };

  // get all Active Unit
  const GetAllActiveUnit = async (ids) => {
    if (ids) {
      setOpenLoader(true);
      try {
        const res = await axios.instance.get(`/GetOneUnit/${ids}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        });
        setUnitData(res.data);
        // console.log(selectedUserTypeId)
        handleCompanyAndUserType(selectedUserTypeId.UserType, ids, res.data);
        setOpenLoader(false);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    } else {
      setUnitData([]);
    }
  };

  // get all Active Line
  const GetAllActiveLine = async (ids) => {
    if (ids) {
      setOpenLoader(true);
      try {
        const res = await axios.instance.get(`/GetOneUnitLineLog/${ids}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        });
        setLineData(res.data);
        setOpenLoader(false);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    } else {
      setLineData([]);
    }
  };

  // get all Active Unit
  const handleCompanyAndUserType = async (UserType, ids, Data) => {
    if (UserType && ids.length > 0) {
      const array = Data.map((obj) => obj.Unit_Id);
      const arrayString = array.join(', ');
      try {
        const res = await axios.instance.get(`/GetOneUnitLineLog/${arrayString}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        });
        const availableUnits = Data.filter(
          (company) => !unitLogData.some((selected) => selected.Unit_Id === company.Unit_Id)
        );

        const availableLineData = res.data.filter(
          (company) =>
            !lineLogData.some(
              (selected) => selected.Line_id === company.Line_id && selected.Unit_Id === company.Unit_Id
            )
        );
        if (UserType === 'Admin' || UserType === 'IE') {
          setUnitLogData([...unitLogData, ...availableUnits]);
          setLineLogData([...lineLogData, ...availableLineData]);
        } else if (UserType === 'Supervisor') {
          setLineLogData([...lineLogData, ...availableLine]);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  };

  // get all Users Request
  const GetOneCompanyLog = async (id) => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetOneCompanyLog/${id}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setLogData(res.data);
      const array = res.data.map((obj) => obj.Company_Id);
      const arrayString = array.join(', ');
      GetAllActiveUnit(arrayString);
      setOpenLoader(false);
      // console.log('users', res.data);
    } catch (error) {
      console.error('Error fetching courses:', error);
    }
  };

  // get all Users Request
  const GetOneUnitLog = async (id) => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetOneUnitLog/${id}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setUnitLogData(res.data);
      const array = res.data.map((obj) => obj.Unit_Id);
      const arrayString = array.join(', ');
      GetAllActiveLine(arrayString);
      setOpenLoader(false);
      // console.log('users', res.data);
    } catch (error) {
      console.error('Error fetching courses:', error);
    }
  };

  // get all Users Request
  const GetOneLineLog = async (id) => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetOneLineLog/${id}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setLineLogData(res.data);
      setOpenLoader(false);
      // console.log('users', res.data);
    } catch (error) {
      console.error('Error fetching courses:', error);
    }
  };

  const GetOneProcessLog = async (id) => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetOneProcessLog/${id}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setProcessLogData(res.data);
      setOpenLoader(false);
      // console.log('users', res.data);
    } catch (error) {
      console.error('Error fetching courses:', error);
    }
  };

  // post Request to Add new record
  const InsertUser = async (newUser) => {
    try {
      const res = await axios.instance.post('/InsertUsers', newUser, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      // console.log('UserAccessID', res.data[0].UserAccessID);
      if (loginAccess === 'Y') {
        DeleteAndInsertLogs(res.data[0].UserAccessID);
        DeleteAndInsertUnitLogs(res.data[0].UserAccessID);
        DeleteAndInsertLineLogs(res.data[0].UserAccessID);
        DeleteAndInsertProcessLogs(res.data[0].UserAccessID);
      }

      getUsers(userTypeFilter === 'Employee' ? 'N' : 'Y');
      setAlertType('success');
      setAlertMessage('New User Added Successfully!');
      setopenAlert(true);
    } catch (error) {
      console.error('Error adding User:', error);
      setAlertType('error');
      setAlertMessage('Failed to add the User.');
      setopenAlert(true);
    }
  };

  // put Request to edit record
  const updateUser = async (userId, updatedUser) => {
    try {
      const res = await axios.instance.put(`/UpdateUsers/${userId}`, updatedUser, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      if (loginAccess === 'Y') {
        DeleteAndInsertLogs(editID);
        DeleteAndInsertUnitLogs(editID);
        DeleteAndInsertLineLogs(editID);
        DeleteAndInsertProcessLogs(editID);
      } else {
        DeleteAllLogs(editID);
      }
      setopenAlert(true);
      setEditID();
      getUsers(userTypeFilter === 'Employee' ? 'N' : 'Y');
      setAlertType('success');
      setAlertMessage('User Updated Successfully!');
    } catch (error) {
      console.error('Error updating User:', error);
      setAlertType('error');
      setAlertMessage('Failed to update the User.');
      setopenAlert(true);
    }
  };

  // delete Request to delete record
  const deleteUser = async (userId) => {
    try {
      await axios.instance
        .delete(`/DeleteUsers/${userId}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        })
        .then((res) => {
          if (res.data === '') {
            DeleteAllLogs(userId);
            getUsers(userTypeFilter === 'Employee' ? 'N' : 'Y');
            setOpenDelete(false);
            setAlertType('warning');
            setAlertMessage('User Deleted Successfully!');
            setopenAlert(true);
          } else {
            getUsers(userTypeFilter === 'Employee' ? 'N' : 'Y');
            setOpenDelete(false);
            setAlertType('error');
            setAlertMessage("Oops! Can't delete this data. It's connected to other information.");
            setopenAlert(true);
          }
          // console.log(res.data);
        });
    } catch (error) {
      console.error('Error deleting User:', error);
      setAlertType('error');
      setAlertMessage('Failed to delete the User.');
      setopenAlert(true);
    }
  };

  // Delete and Insert for company log
  const DeleteAndInsertLogs = (userId) => {
    setOpenLoader(true);
    return axios.instance
      .delete(`/DeleteCompanyAllLogs/${userId}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(() => {
        const detailPromises = logData.map((obj) => {
          const insertData = {
            // ...obj,
            Company_Name: obj.Company_Name,
            Company_Id: obj.Company_Id,
            UserAccessID: userId,
            CreatedBy: sessionStorage.getItem('UserID'),
          };

          return axios.instance.post('/InsertCompanyLogDtl', insertData, {
            headers: {
              Authorization: tokent,
              'Content-Type': 'application/json',
            },
          });
        });

        return Promise.all(detailPromises)
          .then((detailRes) => {
            // setAlertType('success');
            // setAlertMessage('Company Logs Updated Successfully!');
            // setopenAlert(true);
            resetFields();
            setTimeout(() => {
              setopenAlert(false);
              setOpenLoader(false);
            }, 2000);
            return detailRes;
          })
          .catch((error) => {
            console.error('Error adding detail data:', error);
            // setAlertType('error');
            // setAlertMessage('Failed to add detail data.');
            setOpenLoader(false);
            // setopenAlert(true);
            return Promise.reject(error);
          });
      })
      .catch((error) => {
        console.error('Error deleting access:', error);
        // setAlertType('error');
        // setAlertMessage('Failed to delete access.');
        setOpenLoader(false);
        // setopenAlert(true);
        return Promise.reject(error);
      });
  };

  // delete details only for company log
  const DeleteAllLogs = async (userId) => {
    try {
      await axios.instance
        .delete(`/DeleteCompanyAllLogs/${userId}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        })
        .then((res) => {
          if (res.data === '') {
            getUsers(userTypeFilter === 'Employee' ? 'N' : 'Y');
            setOpenDelete(false);
          } else {
            getUsers(userTypeFilter === 'Employee' ? 'N' : 'Y');
            setOpenDelete(false);
            // setAlertType('error');
            // setAlertMessage("Oops! Can't delete this data. It's connected to other information.");
            // setopenAlert(true);
          }
          // console.log(res.data);
        });
    } catch (error) {
      console.error('Error deleting User:', error);
      // setAlertType('error');
      // setAlertMessage('Failed to delete the User.');
      // setopenAlert(true);
    }
  };

  // Delete and Insert for unit log
  const DeleteAndInsertUnitLogs = (userId) => {
    setOpenLoader(true);
    return axios.instance
      .delete(`/DeleteUnitAllLogs/${userId}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(() => {
        const detailPromises = unitLogData.map((obj) => {
          const insertData = {
            // ...obj,
            Company_Name: obj.Company_Name,
            Company_Id: obj.Company_Id,
            Unit_Name: obj.Unit_Name,
            Unit_Id: obj.Unit_Id,
            UserAccessID: userId,
            CreatedBy: sessionStorage.getItem('UserID'),
          };

          return axios.instance.post('/InsertUnitLogDtl', insertData, {
            headers: {
              Authorization: tokent,
              'Content-Type': 'application/json',
            },
          });
        });

        return Promise.all(detailPromises)
          .then((detailRes) => {
            // setAlertType('success');
            // setAlertMessage('Company Logs Updated Successfully!');
            // setopenAlert(true);
            resetFields();
            setTimeout(() => {
              // setopenAlert(false);
              setOpenLoader(false);
            }, 2000);
            return detailRes;
          })
          .catch((error) => {
            console.error('Error adding detail data:', error);
            // setAlertType('error');
            // setAlertMessage('Failed to add detail data.');
            setOpenLoader(false);
            // setopenAlert(true);
            return Promise.reject(error);
          });
      })
      .catch((error) => {
        console.error('Error deleting access:', error);
        // setAlertType('error');
        // setAlertMessage('Failed to delete access.');
        setOpenLoader(false);
        // setopenAlert(true);
        return Promise.reject(error);
      });
  };

  // Delete and Insert for unit log
  const DeleteAndInsertLineLogs = (userId) => {
    setOpenLoader(true);
    return axios.instance
      .delete(`/DeleteLineAllLogs/${userId}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(() => {
        const detailPromises = lineLogData.map((obj) => {
          const insertData = {
            // ...obj,
            Unit_Name: obj.Unit_Name,
            Unit_Id: obj.Unit_Id,
            Line_Name: obj.Line_Name,
            Line_Id: obj.Line_id,
            UserAccessID: userId,
            CreatedBy: sessionStorage.getItem('UserID'),
          };

          return axios.instance.post('/InsertLineLogDtl', insertData, {
            headers: {
              Authorization: tokent,
              'Content-Type': 'application/json',
            },
          });
        });

        return Promise.all(detailPromises)
          .then((detailRes) => {
            // setAlertType('success');
            // setAlertMessage('Company Logs Updated Successfully!');
            // setopenAlert(true);
            resetFields();
            setTimeout(() => {
              // setopenAlert(false);
              setOpenLoader(false);
            }, 2000);
            return detailRes;
          })
          .catch((error) => {
            console.error('Error adding detail data:', error);
            // setAlertType('error');
            // setAlertMessage('Failed to add detail data.');
            setOpenLoader(false);
            // setopenAlert(true);
            return Promise.reject(error);
          });
      })
      .catch((error) => {
        console.error('Error deleting access:', error);
        // setAlertType('error');
        // setAlertMessage('Failed to delete access.');
        setOpenLoader(false);
        // setopenAlert(true);
        return Promise.reject(error);
      });
  };

  // Delete and Insert for Process log
  const DeleteAndInsertProcessLogs = (userId) => {
    setOpenLoader(true);
    return axios.instance
      .delete(`/DeleteProcessAllLogs/${userId}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(() => {
        const detailPromises = processLogData.map((obj) => {
          const insertData = {
            ProcessId: obj.ProcessId,
            ProcessName: obj.ProcessName,
            UserAccessID: userId,
            CreatedBy: sessionStorage.getItem('UserID'),
          };

          return axios.instance.post('/InsertProcessLogDtl', insertData, {
            headers: {
              Authorization: tokent,
              'Content-Type': 'application/json',
            },
          });
        });

        return Promise.all(detailPromises)
          .then((detailRes) => {
            resetFields();
            setTimeout(() => {
              setOpenLoader(false);
            }, 2000);
            return detailRes;
          })
          .catch((error) => {
            console.error('Error adding detail data:', error);
            setOpenLoader(false);
            return Promise.reject(error);
          });
      })
      .catch((error) => {
        console.error('Error deleting access:', error);
        setOpenLoader(false);
        return Promise.reject(error);
      });
  };

  const resetFields = () => {
    setLogData([]);
    setUnitLogData([]);
    setLineLogData([]);
    setUnitData([]);
    setLineData([]);
    setProcessLogData([]);
    setUserCode('');
    setUserName('');
    setEmail('');
    setPhoneNumber('');
    setGrade('');
    setSalary('');
    setUserPassword('');
    setSelectedDepartmentId(null);
    setSelectedUserTypeId(null);
    setSelectedDesignationId(null);
    setSelectedLineValue(null);
    setGender('M');
    setLoginAccess('N');
    setActiveStatus('Y');
    errors.UserCode = false;
    errors.UserName = false;
    errors.Email = false;
    errors.PhoneNumber = false;
    errors.Grade = false;
    errors.Line = false;
    errors.Salary = false;
    errors.UserPassword = false;
    errors.DepartmentId = false;
    errors.DesignationId = false;
    errors.gender = false;
    errors.ActiveStatus = false;
    errors.logSelected = false;
    errors.unitlogSelected = false;
    errors.linelogSelected = false;
    errors.processlogSelected = false;
    errors.UserTypeId = false;
    helperTexts.UserCode = '';
    helperTexts.UserName = '';
    helperTexts.Email = '';
    helperTexts.PhoneNumber = '';
    helperTexts.Grade = '';
    helperTexts.Line = '';
    helperTexts.Salary = '';
    helperTexts.UserPassword = '';
    helperTexts.DepartmentId = '';
    helperTexts.DesignationId = '';
    helperTexts.gender = '';
    helperTexts.logSelected = false;
    helperTexts.unitlogSelected = false;
    helperTexts.linelogSelected = false;
    helperTexts.processlogSelected = false;
    helperTexts.ActiveStatus = '';
    helperTexts.UserTypeId = '';
  };

  // submit button on add or edit
  const handleSubmit = (event) => {
    // console.log(unitLogData, lineLogData)
    event.preventDefault();

    const inputValidation =
      errors.UserCode ||
      errors.UserName ||
      errors.Email ||
      errors.PhoneNumber ||
      errors.Grade ||
      errors.Line ||
      errors.Salary ||
      (loginAccess === 'Y' && errors.UserPassword) ||
      errors.DepartmentId ||
      errors.DesignationId ||
      errors.gender ||
      errors.ActiveStatus ||
      !UserCode ||
      !UserName ||
      !Salary ||
      (loginAccess === 'Y' && !UserPassword) ||
      !selectedDepartmentId ||
      !selectedGradeValue ||
      !selectedLineValue ||
      (loginAccess === 'Y' && !selectedUserTypeId) ||
      !selectedDesignationId ||
      (loginAccess === 'Y' && logData.length === 0) ||
      (loginAccess === 'Y' && unitLogData.length === 0) ||
      (loginAccess === 'Y' && lineLogData.length === 0) ||
      (loginAccess === 'Y' && processLogData.length === 0) ||
      !gender ||
      !ActiveStatus;

    const conditions = {
      UserCodeError: errors.UserCode,
      UserNameError: errors.UserName,
      EmailError: errors.Email,
      PhoneNumberError: errors.PhoneNumber,
      GradeError: errors.Grade,
      LineError: errors.Line,
      SalaryError: errors.Salary,
      UserPasswordError: errors.UserPassword,
      DepartmentIdError: errors.DepartmentId,
      DesignationIdError: errors.DesignationId,
      GenderError: errors.gender,
      ActiveStatusError: errors.ActiveStatus,
      MissingUserCode: !UserCode,
      MissingUserName: !UserName,
      // MissingEmail: !Email,
      // MissingPhoneNumber: !PhoneNumber,
      MissingUserPassword: loginAccess === 'Y' && !UserPassword,
      MissingSelectedDepartmentId: !selectedDepartmentId,
      MissingSelectedUserTypeId: loginAccess === 'Y' && !selectedUserTypeId,
      MissingSelectedDesignationId: !selectedDesignationId,
      MissingLogData: loginAccess === 'Y' && logData.length === 0,
      MissingUnitLogData: loginAccess === 'Y' && unitLogData.length === 0,
      MissingLineLogData: loginAccess === 'Y' && lineLogData.length === 0,
      MissingProcessLogData: loginAccess === 'Y' && processLogData.length === 0,
      MissingGender: !gender,
      MissingActiveStatus: !ActiveStatus,
    };

    // Iterate through the conditions object using forEach
    Object.entries(conditions).forEach(([key, value]) => {
      if (value) {
        console.log(`${key} is causing inputValidation to be true.`);
      }
    });

    // const inputValidation = Object.values(conditions).some(condition => condition);

    // console.log(inputValidation, 'inputValidation')
    if (inputValidation) {
      if (!UserCode) {
        setErrors((prevErrors) => ({ ...prevErrors, UserCode: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          UserCode: 'please enter employee Code',
        }));
      }
      if (!UserName) {
        setErrors((prevErrors) => ({ ...prevErrors, UserName: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          UserName: 'please enter employee Name',
        }));
      }
      if (!Salary) {
        setErrors((prevErrors) => ({ ...prevErrors, Salary: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          Salary: 'please enter employee salary',
        }));
      }
      if (!selectedGradeValue) {
        setErrors((prevErrors) => ({ ...prevErrors, Grade: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          Grade: 'please select grade',
        }));
      }
      if (!selectedLineValue) {
        setErrors((prevErrors) => ({ ...prevErrors, Line: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          Line: 'please select Line',
        }));
      }

      if (loginAccess === 'Y') {
        // console.log('SPD Emergrncy')
        if (!logData || logData.length === 0) {
          setErrors((prevErrors) => ({ ...prevErrors, logSelected: true }));
          setHelperTexts((prevHelperTexts) => ({
            ...prevHelperTexts,
            logSelected: 'please add company to access login',
          }));
        }
        if (!unitLogData || unitLogData.length === 0) {
          setErrors((prevErrors) => ({ ...prevErrors, unitlogSelected: true }));
          setHelperTexts((prevHelperTexts) => ({
            ...prevHelperTexts,
            unitlogSelected: 'please add Unit to access login',
          }));
        }
        if (!lineLogData || lineLogData.length === 0) {
          setErrors((prevErrors) => ({ ...prevErrors, linelogSelected: true }));
          setHelperTexts((prevHelperTexts) => ({
            ...prevHelperTexts,
            linelogSelected: 'please add Line to access login',
          }));
        }
        if (!processLogData || processLogData.length === 0) {
          setErrors((prevErrors) => ({ ...prevErrors, processlogSelected: true }));
          setHelperTexts((prevHelperTexts) => ({
            ...prevHelperTexts,
            processlogSelected: 'please add process to access login',
          }));
        }
        if (!UserPassword) {
          setErrors((prevErrors) => ({ ...prevErrors, UserPassword: true }));
          setHelperTexts((prevHelperTexts) => ({
            ...prevHelperTexts,
            UserPassword: 'please Enter User Password',
          }));
        }
        if (!selectedUserTypeId) {
          setErrors((prevErrors) => ({ ...prevErrors, UserTypeId: true }));
          setHelperTexts((prevHelperTexts) => ({
            ...prevHelperTexts,
            UserTypeId: 'please select User Type',
          }));
        }
      }

      if (!selectedDepartmentId) {
        setErrors((prevErrors) => ({ ...prevErrors, DepartmentId: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          DepartmentId: 'please select Department',
        }));
      }
      if (!selectedDesignationId) {
        setErrors((prevErrors) => ({ ...prevErrors, DesignationId: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          DesignationId: 'please select Designation',
        }));
      }
      if (!selectedGradeValue) {
        setErrors((prevErrors) => ({ ...prevErrors, Grade: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          Grade: 'please select Grade',
        }));
      }
      if (!selectedLineValue) {
        setErrors((prevErrors) => ({ ...prevErrors, Line: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          Line: 'please select Line',
        }));
      }
      if (!ActiveStatus) {
        setErrors((prevErrors) => ({ ...prevErrors, ActiveStatus: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          ActiveStatus: 'please select active Status',
        }));
      }
      if (!gender) {
        setErrors((prevErrors) => ({ ...prevErrors, gender: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          gender: 'please select gender',
        }));
      }
    }

    if (inputValidation) {
      return;
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      UserCode: false,
      UserName: false,
      Email: false,
      PhoneNumber: false,
      Grade: false,
      Line: false,
      Salary: false,
      UserPassword: false,
      DepartmentId: false,
      DesignationId: false,
      ActiveStatus: false,
    }));

    setHelperTexts((prevHelperTexts) => ({
      ...prevHelperTexts,
      UserCode: '',
      UserName: '',
      Email: '',
      PhoneNumber: '',
      Grade: '',
      Line: '',
      Salary: '',
      UserPassword: '',
      DepartmentId: '',
      DesignationId: '',
      ActiveStatus: '',
    }));

    const newData = {
      UserCode,
      UserName,
      Email,
      PhoneNumber,
      GradeId: selectedGradeValue.GradeValue,
      LineId: selectedLineValue.Line_id,
      Salary,
      UserPassword,
      DepartmentId: selectedDepartmentId.DepartmentId,
      DesignationId: selectedDesignationId.DesignationId,
      ActiveStatus,
      gender,
      loginAccess,
      UserType: loginAccess === 'N' ? '' : selectedUserTypeId.UserType,
      IsContractEmp: IsContractEmp ? 'Y' : 'N', 
      [operation === 'Edit' ? 'ModifyedBy' : 'CreatedBy']: sessionStorage.getItem('UserID'),
    };

    if (operation === 'Add') {
      InsertUser(newData);
    } else if (operation === 'Edit') {
      updateUser(editID, newData);
    }
    resetFields();
    handleClose();
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'UserCode') setUserCode(value);
    if (name === 'UserName') setUserName(value);
    if (name === 'Email') setEmail(value);
    if (name === 'PhoneNumber') setPhoneNumber(value);
    if (name === 'Salary') setSalary(value);
    if (name === 'UserPassword') setUserPassword(value);
    if (name === 'gender') setGender(value);
    if (name === 'login') setLoginAccess(value);
    if (name === 'ActiveStatus') setActiveStatus(value);
    validateInput(name, value);
  };

  // validations
  const validateInput = (name, value) => {
    let error = false;
    let helperText = '';

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const contactRegex = /^\d{10}$/;
    const nameRegex = /^[A-Za-z\s.]+$/;
    const isDataExists = usersData.some((data) => data.UserCode.toLowerCase() === value.toLowerCase().trim());
    const isDataExistsinEdit = usersData.some(
      (data) => data.UserCode.toLowerCase() === value.toLowerCase().trim() && data.UserAccessID !== editID
    );

    if (name === 'UserName') {
      if (!value.trim()) {
        error = true;
        helperText = 'employee name field cannot be empty';
        setIsFormSubmitted(false);
      } else if (!nameRegex.test(value)) {
        error = true;
        helperText = 'only letters, spaces, and dots are allowed';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    } else if (name === 'UserCode') {
      if (!value.trim()) {
        error = true;
        helperText = 'employee code cannot be empty';
        setIsFormSubmitted(false);
      } else if (operation === 'Add' && isDataExists) {
        error = true;
        helperText = 'employee code already exists';
        setIsFormSubmitted(false);
      } else if (operation === 'Edit' && isDataExistsinEdit) {
        error = true;
        helperText = 'employee code already exists';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    } else if (name === 'Email') {
      if (value.length > 0 && !emailRegex.test(value)) {
        error = true;
        helperText = 'please enter a valid email';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    } else if (name === 'PhoneNumber') {
      if (value.length > 0 && !contactRegex.test(value) && value.length > 10) {
        error = true;
        helperText = 'cannot exceed more than 10 numbers';
        setIsFormSubmitted(false);
      } else if (value.length > 0 && value.length < 10) {
        error = true;
        helperText = 'enter 10 digit mobile numbers';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    } else if (name === 'Salary') {
      if (!value.trim()) {
        error = true;
        helperText = 'salary cannot be empty';
        setIsFormSubmitted(false);
      } else if (value.length > 0 && !contactRegex.test(value) && value.length > 10) {
        error = true;
        helperText = 'cannot exceed more than 10 numbers';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    }
    //  else if (name === 'UserPassword') {
    //   if (value.length > 0 && !passWordRegex.test(value)) {
    //     error = true;
    //     helperText =
    //       'Password must meet the requirements: at least one uppercase letter, one lowercase letter or number, and one special character (!@#$%^&*), for example; User@123456';
    //     setIsFormSubmitted(false);
    //   } else {
    //     setIsFormSubmitted(true);
    //   }
    // }
    else if (name === 'gender') {
      if (!value.trim()) {
        error = true;
        helperText = 'plaese select gender';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    } else if (name === 'ActiveStatus') {
      if (!value.trim()) {
        error = true;
        helperText = 'Plaese select user status';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    } 

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
    setHelperTexts((prevHelperTexts) => ({
      ...prevHelperTexts,
      [name]: helperText,
    }));
  };

  const handleInputChangeSelect = (event, newValue) => {
    setSelectedDepartmentId(newValue);

    if (!newValue) {
      setErrors((prevErrors) => ({ ...prevErrors, DepartmentId: true }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, DepartmentId: 'please select department' }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, DepartmentId: false }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, DepartmentId: '' }));
    }
  };

  const handleInputChangeDesignationSelect = (event, newValue) => {
    setSelectedDesignationId(newValue);

    if (!newValue) {
      setErrors((prevErrors) => ({ ...prevErrors, DesignationId: true }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, DesignationId: 'please select designation' }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, DesignationId: false }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, DesignationId: '' }));
    }
  };

  const handleUserTypeInputChangeSelect = (event, newValue) => {
    setSelectedUserTypeId(newValue);
    if (!newValue) {
      setErrors((prevErrors) => ({ ...prevErrors, UserTypeId: true }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, UserTypeId: 'please select usertype' }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, UserTypeId: false }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, UserTypeId: '' }));
    }

    if (logData.length > 0) {
      setUnitLogData([]);
      setLineLogData([]);
      // if (newValue.UserType === 'Admin' || newValue.UserType === 'IE') {
      //   setUnitLogData([...unitLogData, ...availableUnits])
      //   setLineLogData([...lineLogData, ...availableLine])
      // } else if (newValue.UserType === 'Supervisor') {
      //   setLineLogData([...lineLogData, ...availableLine])
      // }
      handleCompanyAndUserType(newValue.UserType, logData, unitData);
    }
  };

  const handleGradeInputChangeSelect = (event, newValue) => {
    setSelectedGradeValue(newValue);
    if (!newValue) {
      setErrors((prevErrors) => ({ ...prevErrors, Grade: true }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, Grade: 'please select grade' }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, Grade: false }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, Grade: '' }));
    }
  };

  const handleLineInputChangeSelect = (event, newValue) => {
    setSelectedLineValue(newValue);
    if (!newValue) {
      setErrors((prevErrors) => ({ ...prevErrors, Line: true }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, Line: 'please select grade' }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, Line: false }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, Line: '' }));
    }
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;
    if (value.length > 0) {
      validateInput(name, value);
    }
  };

  // handle edit popup dialog
  const handleAddOpen = () => {
    setOpen(true);
    setOperation('Add');
  };

  const handleEdit = (user) => {
    setEditID(user.UserAccessID);
    GetOneCompanyLog(user.UserAccessID);
    GetOneUnitLog(user.UserAccessID);
    GetOneLineLog(user.UserAccessID);
    GetOneProcessLog(user.UserAccessID);
    setUserCode(user.UserCode);
    setUserName(user.Users);
    setEmail(user.Email);
    setPhoneNumber(user.PhoneNumber);
    setIsContractEmp(user.IsContractEmp === 'Y');

    setSalary(user.Salary);
    setUserPassword(user.UserPassword);
    const selectedDept = deptData.find((obj) => obj.DepartmentId === user.DepartmentId);
    setSelectedDepartmentId(selectedDept);
    const selectedDesignn = designData.find((obj) => obj.DesignationId === user.DesignationId);
    setSelectedDesignationId(selectedDesignn);
    const selectedUserType = userTypeData.find((obj) => obj.UserType === user.UserType);
    setSelectedUserTypeId(selectedUserType);
    const selecteGrade = gradeData.find((obj) => obj.GradeValue === user.GradeId);
    setSelectedGradeValue(selecteGrade);
    const selectedLine = LineMstData.find((obj) => Number(obj.Line_id) === Number(user.LineId));
    setSelectedLineValue(selectedLine);
    setGender(user.Gender);
    setLoginAccess(user.loginAccess);
    setActiveStatus(user.ActiveStatus);
    handleEditOpen();
  };

  const handleEditOpen = () => {
    setOpen(true);
    setOperation('Edit');
  };

  const handleDelete = (courseId) => {
    setOpenDelete(true);
    setIdToDelete(courseId);
  };

  const handleDeleteConfirmed = (courseId) => {
    deleteUser(courseId);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setopenAlert(false);
  };

  const handleCloseAlert = () => {
    setopenAlert(false);
  };

  const handleClose = () => {
    resetFields();
    setOpen(false);
  };

  // search & filter
  const filteredData = usersData.filter((enq) => {
    const searchTermLowerCase = searchTerm.toLowerCase();
    return Object.values(enq).some((value) => {
      if (typeof value === 'string') {
        return value.toLowerCase().includes(searchTermLowerCase);
      }
      return false;
    });
  });

  // pagination
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, filteredData.length - page * rowsPerPage);
  const totalRows = filteredData.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const currentPage = Math.max(0, Math.min(page, totalPages - 1)); // Clamp to the range [0, totalPages - 1]

  // Reset page to 0 when searchTerm changes
  useEffect(() => {
    setPage(0);
  }, [searchTerm]);

  const handleChangeSelection = (event, newValue) => {

    if (selectedUserTypeId == null) {
      toastr.warning('Please select user type first')
    } else {
      setLogData(newValue);
      const array = newValue.map((obj) => obj.Company_Id);
      const arrayString = array.join(', ');
      GetAllActiveUnit(arrayString);
      if (loginAccess === 'Y' && !newValue) {
        setErrors((prevErrors) => ({ ...prevErrors, logSelected: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          logSelected: 'please select & add companies in list',
        }));
      } else {
        setErrors((prevErrors) => ({ ...prevErrors, logSelected: false }));
        setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, logSelected: '' }));
      }
    }
  };

  const handleUnitLogChangeSelection = (event, newValue) => {
    if (selectedUserTypeId == null) {
      toastr.warning('Please select user type first')
    }
    else {
      setUnitLogData(newValue);
      const array = newValue.map((obj) => obj.Unit_Id);
      const arrayString = array.join(', ');
      GetAllActiveLine(arrayString);
      if (loginAccess === 'Y' && !newValue) {
        setErrors((prevErrors) => ({ ...prevErrors, unitlogSelected: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          unitlogSelected: 'please select & add units in list',
        }));
      } else {
        setErrors((prevErrors) => ({ ...prevErrors, unitlogSelected: false }));
        setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, unitlogSelected: '' }));
      }
    }
  };

  const handleLineLogChangeSelection = (event, newValue) => {
    setLineLogData(newValue);
    if (loginAccess === 'Y' && !newValue) {
      setErrors((prevErrors) => ({ ...prevErrors, linelogSelected: true }));
      setHelperTexts((prevHelperTexts) => ({
        ...prevHelperTexts,
        linelogSelected: 'please select & add Line in list',
      }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, linelogSelected: false }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, linelogSelected: '' }));
    }
  };

  const handleProcessLogChangeSelection = (event, newValue) => {
    setProcessLogData(newValue);
    if (loginAccess === 'Y' && !newValue) {
      setErrors((prevErrors) => ({ ...prevErrors, processlogSelected: true }));
      setHelperTexts((prevHelperTexts) => ({
        ...prevHelperTexts,
        processlogSelected: 'please select & add process in list',
      }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, processlogSelected: false }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, processlogSelected: '' }));
    }
  };

  const availableCompanies = companyData.filter(
    (company) => !logData.some((selected) => selected.Company_Id === company.Company_Id)
  );

  const availableUnits = unitData.filter(
    (company) => !unitLogData.some((selected) => selected.Unit_Id === company.Unit_Id)
  );

  const availableLine = lineData.filter(
    (company) =>
      !lineLogData.some((selected) => selected.Line_id === company.Line_id && selected.Unit_Id === company.Unit_Id)
  );

  return (
    <>
      <Snackbar
        style={{ marginTop: '45px' }}
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={(props) => <Slide {...props} direction={'right'} />}
      >
        <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      <Container maxWidth={'xl'} elevation={3}>
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              background: 'linear-gradient(to right, #314755, #26a0da)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Employee/User Master
            </Typography>
          </Typography>
        </Grid>

        {/* search & add button */}
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} spacing={2} my={2}>
          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label="Search"
            size="small"
            onChange={(e) => setSearchTerm(e.target.value)}
            value={searchTerm}
          />
          <Stack direction={'row'} justifyContent={'end'} spacing={2}>
            <FormControl size="small" component="fieldset">
              <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={2}>
                {/* <FormLabel component="legend"></FormLabel> */}
                <RadioGroup
                  row
                  value={userTypeFilter}
                  onChange={(e) => {
                    setUserTypeFilter(e.target.value);
                  }}
                >
                  <FormControlLabel
                    value="Employee"
                    control={<Radio />}
                    onClick={() => getUsers('N')}
                    label="Employee"
                  />
                  <FormControlLabel
                    value="User"
                    control={<Radio />}
                    onClick={() => getUsers('Y')}
                    label="User"
                  />
                </RadioGroup>
              </Stack>
            </FormControl>
            <Button
              variant="outlined"
              color="error"
              sx={{ boxShadow: 1 }}
              onClick={downloadPDF}
              startIcon={<PictureAsPdfIcon />}
            >
              PDF
            </Button>
            <Button
              variant="outlined"
              color="success"
              sx={{ boxShadow: 1 }}
              onClick={downloadExcel}
              startIcon={<GridOnIcon />}
            >
              Excel
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              sx={{ boxShadow: 1 }}
              onClick={handleAddOpen}
              startIcon={<PlaylistAddIcon />}
            >
              Add Employee/User
            </Button>
          </Stack>
        </Stack>

        {/* table  */}
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <StyledTableCell align="center">S.No</StyledTableCell>

                {/* Personal Information */}
                <StyledTableCell align="left">Employee Code</StyledTableCell>
                <StyledTableCell align="left">Name</StyledTableCell>
                <StyledTableCell align="left">Gender</StyledTableCell>
                <StyledTableCell align="left">Email</StyledTableCell>
                <StyledTableCell align="left">Phone</StyledTableCell>

                {/* Job Details */}
                <StyledTableCell align="left">Department</StyledTableCell>
                <StyledTableCell align="left">Designation</StyledTableCell>
                <StyledTableCell align="left">Grade</StyledTableCell>
                <StyledTableCell align="right">Salary</StyledTableCell>
                <StyledTableCell align="left">Line</StyledTableCell>

                {/* System / Access Info */}
                {userTypeFilter === 'User' && (
                  <StyledTableCell align="left">Password</StyledTableCell>
                )}

                {/* Status & Actions */}
                <StyledTableCell align="center">Status</StyledTableCell>
                <StyledTableCell align="center">Actions</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {(rowsPerPage > 0
                ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : filteredData
              ).map((user, index) => (
                <TableRow key={user.UserAccessID} hover>
                  <TableCell align="center">{user.SNo}</TableCell>
                  <TableCell align="left">{user.UserCode}</TableCell>
                  <TableCell align="left">{user.Users}</TableCell>
                  <TableCell align="left">{user.Gender === 'M' ? 'Male' : 'Female'}</TableCell>
                  <TableCell align="left">{user.Email}</TableCell>
                  <TableCell align="left">{user.PhoneNumber}</TableCell>
                  <TableCell align="left">{user.DepartmentDescription}</TableCell>
                  <TableCell align="left">{user.DesignationDescription}</TableCell>
                  <TableCell align="left">{user.GradeName}</TableCell>
                  <TableCell align="right">{user.Salary}</TableCell>
                  <TableCell align="left">{user.LineName}</TableCell>
                  {userTypeFilter === 'User' && <TableCell align="left">{user.UserPassword}</TableCell>}

                  <TableCell align="center">
                    {user.ActiveStatus === 'Y' ? (
                      <Chip icon={<CheckCircleOutlineIcon />} color="success" size="small" label="Active" />
                    ) : (
                      <Chip icon={<HighlightOffIcon />} color="error" size="small" label="InActive" />
                    )}
                  </TableCell>

                  <TableCell align="center" sx={{ padding: '0' }}>
                    <IconButton aria-label="Edit" onClick={() => handleEdit(user)}>
                      <EditIcon color="primary" />
                    </IconButton>
                    <IconButton aria-label="Delete" onClick={() => handleDelete(user.UserAccessID)}>
                      <DeleteForeverIcon color="error" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={11} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={currentPage} // Use the calculated currentPage value
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0); // Reset the page when rowsPerPage changes
          }}
          mt={2}
        />
      </Container>

      <Grid m={2}>
        {/* add new popup form dialog box */}
        <Dialog maxWidth={loginAccess === 'Y' ? 'lg' : 'sm'} open={open} onClose={handleClose} fullWidth>
          <Container component={Paper} elevation={2} sx={{ py: 2 }}>
            <form onSubmit={handleSubmit} noValidate>
              <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mr={1}>
                <Typography variant="h5" textAlign={'left'} pl={2} fontWeight={600} color="primary">
                  {operation} Employee/User
                </Typography>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Stack>
              <Stack direction={'column'}>
                <Grid container spacing={2} p={1} rowSpacing={2} columnSpacing={2}>
                  <Grid item xs={12} md={4} lg={loginAccess === 'Y' ? 4 : 6}>
                    <TextField
                      type="text"
                      variant="outlined"
                      color="primary"
                      label="Emp Code"
                      name="UserCode"
                      value={UserCode === null ? '' : UserCode}
                      onBlur={handleBlur}
                      onChange={handleInputChange}
                      fullWidth
                      required
                      size="small"
                      error={errors.UserCode}
                      helperText={helperTexts.UserCode}
                      className={isFormSubmitted && errors.UserCode ? 'shake-helper-text' : ''}
                    />
                  </Grid>
                  <Grid item xs={12} md={8} lg={loginAccess === 'Y' ? 5 : 6}>
                    <TextField
                      type="text"
                      variant="outlined"
                      color="primary"
                      label="Name"
                      name="UserName"
                      value={UserName === null ? '' : UserName}
                      onBlur={handleBlur}
                      onChange={handleInputChange}
                      fullWidth
                      required
                      size="small"
                      error={errors.UserName}
                      helperText={helperTexts.UserName}
                      className={isFormSubmitted && errors.UserName ? 'shake-helper-text' : ''}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={loginAccess === 'Y' ? 3 : 6}>
                    <Autocomplete
                      size="small"
                      name="department"
                      required
                      options={deptData}
                      getOptionLabel={(obj) => (obj ? obj.DepartmentDescription : '')}
                      value={selectedDepartmentId || null}
                      onChange={handleInputChangeSelect}
                      disableClearable
                      renderInput={(params) => <TextField {...params} label="Department" required />}
                    />
                    {errors.DepartmentId && (
                      <Typography
                        variant="caption"
                        color="error"
                        pl={1}
                        className={isFormSubmitted && errors.DepartmentId ? 'shake-helper-text' : ''}
                      >
                        {errors.DepartmentId && helperTexts.DepartmentId}
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6} lg={loginAccess === 'Y' ? 4 : 6}>
                    <Autocomplete
                      size="small"
                      name="group"
                      options={designData}
                      getOptionLabel={(obj) => (obj ? obj.DesignationDescription : '')}
                      value={selectedDesignationId || null}
                      onChange={handleInputChangeDesignationSelect}
                      disableClearable
                      renderInput={(params) => <TextField {...params} label="Designation" required />}
                    />
                    {errors.DesignationId && (
                      <Typography
                        variant="caption"
                        color="error"
                        pl={1}
                        className={isFormSubmitted && errors.DesignationId ? 'shake-helper-text' : ''}
                      >
                        {errors.DesignationId && helperTexts.DesignationId}
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6} lg={loginAccess === 'Y' ? 4 : 6}>
                    <Autocomplete
                      size="small"
                      name="Grade"
                      required
                      options={gradeData}
                      getOptionLabel={(obj) => (obj ? obj.GradeLable : '')}
                      value={selectedGradeValue || null}
                      onChange={handleGradeInputChangeSelect}
                      renderInput={(params) => <TextField {...params} label="Grade" required />}
                      disableClearable
                    />
                    {errors.Grade && (
                      <Typography
                        variant="caption"
                        color="error"
                        pl={1}
                        className={isFormSubmitted && errors.Grade ? 'shake-helper-text' : ''}
                      >
                        {errors.Grade && helperTexts.Grade}
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6} lg={loginAccess === 'Y' ? 4 : 6}>
                    <TextField
                      type="number"
                      variant="outlined"
                      color="primary"
                      label="Salary"
                      name="Salary"
                      required
                      value={Salary === null ? '' : Salary}
                      onBlur={handleBlur}
                      onChange={handleInputChange}
                      fullWidth
                      size="small"
                      error={errors.Salary}
                      helperText={helperTexts.Salary}
                      className={isFormSubmitted && errors.Salary ? 'shake-helper-text' : ''}
                    />
                  </Grid>
                  <Grid item xs={12} md={3} lg={loginAccess === 'Y' ? 6 : 12}>
                    <TextField
                      type="text"
                      variant="outlined"
                      color="primary"
                      label="Email"
                      name="Email"
                      value={Email === null ? '' : Email}
                      onBlur={handleBlur}
                      onChange={handleInputChange}
                      fullWidth
                      size="small"
                      error={errors.Email}
                      helperText={helperTexts.Email}
                      className={isFormSubmitted && errors.Email ? 'shake-helper-text' : ''}
                    />
                  </Grid>{' '}
                  <Grid item xs={12} md={6} lg={loginAccess === 'Y' ? 6 : 6}>
                    <TextField
                      type="number"
                      variant="outlined"
                      color="primary"
                      label="Phone"
                      name="PhoneNumber"
                      value={PhoneNumber === null ? '' : PhoneNumber}
                      onBlur={handleBlur}
                      onChange={handleInputChange}
                      fullWidth
                      size="small"
                      error={errors.PhoneNumber}
                      helperText={helperTexts.PhoneNumber}
                      className={isFormSubmitted && errors.PhoneNumber ? 'shake-helper-text' : ''}
                    />
                  </Grid>{' '}
                  <Grid item xs={12} md={6} lg={loginAccess === 'Y' ? 4 : 6}>
                    <Autocomplete
                      size="small"
                      name="Line"
                      required
                      options={LineMstData}
                      getOptionLabel={(obj) => (obj ? obj.Line_Name : '')}
                      value={selectedLineValue || null}
                      onChange={handleLineInputChangeSelect}
                      renderInput={(params) => <TextField {...params} label="Line" required />}
                      disableClearable
                    />
                    {errors.Line && (
                      <Typography
                        variant="caption"
                        color="error"
                        pl={1}
                        className={isFormSubmitted && errors.Line ? 'shake-helper-text' : ''}
                      >
                        {errors.Line && helperTexts.Line}
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6} lg={loginAccess === 'Y' ? 3 : 6}>
                    <FormControl size="small" fullWidth component="fieldset">
                      <Stack direction={'row'} justifyContent={'flex-start'} algnItems={'center'} spacing={2}>
                        <FormLabel component="legend" sx={{ pt: 1 }}>
                          Gender
                        </FormLabel>
                        <RadioGroup row value={gender} name="gender" onChange={handleInputChange}>
                          <FormControlLabel value="M" control={<Radio />} label="Male" />
                          <FormControlLabel value="F" control={<Radio />} label="Female" />
                        </RadioGroup>
                      </Stack>
                      {errors.gender && (
                        <Typography
                          variant="caption"
                          color="error"
                          className={isFormSubmitted && errors.gender ? 'shake-helper-text' : ''}
                        >
                          {errors.gender && helperTexts.gender}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                  {loginAccess === 'Y' && (
                    <>
                      <Grid item xs={12} md={6} lg={4}>
                        <TextField
                          type="text"
                          variant="outlined"
                          color="primary"
                          label="Password"
                          name="UserPassword"
                          value={UserPassword === null ? '' : UserPassword}
                          onBlur={handleBlur}
                          onChange={handleInputChange}
                          fullWidth
                          size="small"
                          error={errors.UserPassword}
                          helperText={helperTexts.UserPassword}
                          className={isFormSubmitted && errors.UserPassword ? 'shake-helper-text' : ''}
                        />
                      </Grid>{' '}
                      <Grid item xs={12} md={6} lg={5}>
                        <Autocomplete
                          size="small"
                          name="usertpe"
                          required
                          options={userTypeData}
                          getOptionLabel={(obj) => (obj ? obj.UserType : '')}
                          value={selectedUserTypeId || null}
                          onChange={handleUserTypeInputChangeSelect}
                          renderInput={(params) => <TextField {...params} label="User Type" required />}
                          disableClearable
                        />
                        {errors.UserTypeId && (
                          <Typography
                            variant="caption"
                            color="error"
                            pl={1}
                            className={isFormSubmitted && errors.UserTypeId ? 'shake-helper-text' : ''}
                          >
                            {errors.UserTypeId && helperTexts.UserTypeId}
                          </Typography>
                        )}
                      </Grid>
                      <Grid item xs={12} md={6} lg={6}>
                        <FormControl size="small" fullWidth component="fieldset" id="checkboxes-tags-demo">
                          <Autocomplete
                            multiple
                            id="checkboxes-tags-demo"
                            fullWidth
                            options={availableCompanies}
                            disableCloseOnSelect
                            getOptionLabel={(option) => option.Company_Name}
                            value={logData}
                            onChange={handleChangeSelection}
                            disableClearable
                            renderOption={(props, option, { selected }) => {
                              const { key, ...optionProps } = props;
                              return (
                                <li key={key} {...optionProps}>
                                  {/* <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  /> */}
                                  {option.Company_Name}
                                </li>
                              );
                            }}
                            renderTags={(selected, getTagProps) =>
                              selected.map((option, index) => (
                                <Chip
                                  key={index}
                                  color="primary"
                                  size="small"
                                  variant="outlined"
                                  label={option.Company_Name}
                                  {...getTagProps({ index })}
                                  onDelete={() => {
                                    const newSelected = selected.filter((sel) => sel.Company_Id !== option.Company_Id);
                                    setLogData(newSelected);
                                    handleChangeSelection(null, newSelected);

                                    // To Update Unit whilee remove
                                    const availableUnit = unitLogData.filter(
                                      (company) => option.Company_Id !== company.Company_Id
                                    );
                                    setUnitLogData(availableUnit);

                                    // To Update Line whilee remove
                                    const availableLine = lineLogData.filter(
                                      (company) => option.Unit_Id !== company.Unit_Id
                                    );
                                    setLineLogData(availableLine);
                                  }}
                                />
                              ))
                            }
                            renderInput={(params) => (
                              <TextField {...params} label="Select Companies " placeholder="add company" />
                            )}
                          />
                          {errors.logSelected && (
                            <Typography
                              variant="caption"
                              color="error"
                              className={isFormSubmitted && errors.logSelected ? 'shake-helper-text' : ''}
                            >
                              {errors.logSelected && helperTexts.logSelected}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6} lg={6}>
                        <FormControl size="small" fullWidth component="fieldset" id="checkboxes-tags-demo">
                          <Autocomplete
                            multiple
                            id="checkboxes-tags-demo"
                            fullWidth
                            options={availableUnits}
                            disableCloseOnSelect
                            getOptionLabel={(option) => option.Unit_Name}
                            value={unitLogData}
                            onChange={handleUnitLogChangeSelection}
                            disableClearable
                            renderOption={(props, option, { selected }) => {
                              const { key, ...optionProps } = props;
                              return (
                                <li key={key} {...optionProps}>
                                  {/* <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  /> */}
                                  {option.Unit_Name}
                                </li>
                              );
                            }}
                            renderTags={(selected, getTagProps) =>
                              selected.map((option, index) => (
                                <Chip
                                  key={index}
                                  color="primary"
                                  size="small"
                                  variant="outlined"
                                  label={option.Unit_Name}
                                  {...getTagProps({ index })}
                                  onDelete={() => {
                                    const newSelected = selected.filter((sel) => sel.Unit_Id !== option.Unit_Id);
                                    setUnitLogData(newSelected);
                                    handleUnitLogChangeSelection(null, newSelected);
                                    const availableLine = lineLogData.filter(
                                      (company) => option.Unit_Id !== company.Unit_Id
                                    );
                                    setLineLogData(availableLine);
                                  }}
                                />
                              ))
                            }
                            renderInput={(params) => (
                              <TextField {...params} label="Select Unit " placeholder="add unit" />
                            )}
                          />
                          {errors.unitlogSelected && (
                            <Typography
                              variant="caption"
                              color="error"
                              className={isFormSubmitted && errors.unitlogSelected ? 'shake-helper-text' : ''}
                            >
                              {errors.unitlogSelected && helperTexts.unitlogSelected}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl size="small" fullWidth component="fieldset" id="checkboxes-tags-demo">
                          <Autocomplete
                            multiple
                            id="checkboxes-tags-demo"
                            fullWidth
                            options={availableLine}
                            disableCloseOnSelect
                            getOptionLabel={(option) => option.Line_Name}
                            value={lineLogData}
                            onChange={handleLineLogChangeSelection}
                            disableClearable
                            renderOption={(props, option, { selected }) => {
                              const { key, ...optionProps } = props;
                              return (
                                <li key={key} {...optionProps}>
                                  {/* <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  /> */}
                                  {`${option.Unit_Name}/${option.Line_Name}`}
                                </li>
                              );
                            }}
                            renderTags={(selected, getTagProps) =>
                              selected.map((option, index) => (
                                <Chip
                                  key={index}
                                  color="primary"
                                  size="small"
                                  variant="outlined"
                                  label={`${option.Unit_Name}/${option.Line_Name}`}
                                  {...getTagProps({ index })}
                                  onDelete={() => {
                                    const newSelected = selected.filter((sel) => sel.Line_id !== option.Line_id);
                                    setLineLogData(newSelected);
                                    handleLineLogChangeSelection(null, newSelected);
                                  }}
                                />
                              ))
                            }
                            renderInput={(params) => (
                              <TextField {...params} label="Select Line " placeholder="add line" />
                            )}
                          />
                          {errors.linelogSelected && (
                            <Typography
                              variant="caption"
                              color="error"
                              className={isFormSubmitted && errors.linelogSelected ? 'shake-helper-text' : ''}
                            >
                              {errors.linelogSelected && helperTexts.linelogSelected}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl size="small" fullWidth component="fieldset" id="checkboxes-tags-demo">
                          <Autocomplete
                            multiple
                            id="checkboxes-tags-demo"
                            fullWidth
                            options={ProcessMstData}
                            disableCloseOnSelect
                            getOptionLabel={(option) => option.ProcessName}
                            value={processLogData}
                            onChange={handleProcessLogChangeSelection}
                            disableClearable
                            isOptionEqualToValue={(option, value) => option.ProcessId === value.ProcessId}
                            renderOption={(props, option, { selected }) => {
                              const { key, ...optionProps } = props;
                              return (
                                <li key={key} {...optionProps}>
                                  {/* <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  /> */}
                                  {`${option.ProcessName}`}
                                </li>
                              );
                            }}
                            renderTags={(selected, getTagProps) =>
                              selected.map((option, index) => (
                                <Chip
                                  key={index}
                                  color="primary"
                                  size="small"
                                  variant="outlined"
                                  label={`${option.ProcessName}`}
                                  {...getTagProps({ index })}
                                  onDelete={() => {
                                    const newSelected = selected.filter((sel) => sel.ProcessId !== option.ProcessId);
                                    setProcessLogData(newSelected);
                                    handleProcessLogChangeSelection(null, newSelected);
                                  }}
                                />
                              ))
                            }
                            renderInput={(params) => (
                              <TextField {...params} label="Select Process " placeholder="add process" />
                            )}
                          />
                          {errors.processlogSelected && (
                            <Typography
                              variant="caption"
                              color="error"
                              className={isFormSubmitted && errors.processlogSelected ? 'shake-helper-text' : ''}
                            >
                              {errors.processlogSelected && helperTexts.processlogSelected}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>
                    </>
                  )}
                  {/* <Grid item xs={12} md={6} lg={loginAccess === 'Y' ? 3 : 6}>
                    <FormControl size="small" fullWidth component="fieldset">
                      <Stack direction={'row'} justifyContent={'flex-start'} algnItems={'center'} spacing={2}>
                        <FormLabel component="legend" sx={{ pt: 1 }}>
                          Login Access
                        </FormLabel>
                        <RadioGroup row value={loginAccess} name="login" onChange={handleInputChange}>
                          <FormControlLabel value="Y" control={<Radio />} label="Yes" />
                          <FormControlLabel value="N" control={<Radio />} label="No" />
                        </RadioGroup>
                      </Stack>
                      {errors.loginAccess && (
                        <Typography
                          variant="caption"
                          color="error"
                          className={isFormSubmitted && errors.loginAccess ? 'shake-helper-text' : ''}
                        >
                          {errors.loginAccess && helperTexts.loginAccess}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid> */}
                  <Grid item xs={12} md={12} lg={loginAccess === 'Y' ? 6 : 6}>
                    <FormControl size="small" fullWidth component="fieldset">
                      <Stack direction={'row'} justifyContent={'flex-start'} algnItems={'center'} spacing={2}>
                        <FormLabel component="legend" sx={{ pt: 1 }}>
                          Active Status
                        </FormLabel>
                        <RadioGroup row value={ActiveStatus} name="ActiveStatus" onChange={handleInputChange}>
                          <FormControlLabel value="Y" control={<Radio />} label="Yes" />
                          <FormControlLabel value="N" control={<Radio />} label="No" />
                        </RadioGroup>
                      </Stack>
                      {errors.ActiveStatus && (
                        <Typography
                          variant="caption"
                          color="error"
                          className={isFormSubmitted && errors.ActiveStatus ? 'shake-helper-text' : ''}
                        >
                          {errors.ActiveStatus && helperTexts.ActiveStatus}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                 <Grid item xs={12} md={6} lg={loginAccess === 'Y' ? 3 : 6}>
                  <FormControl size="small">
                  <FormControlLabel
                  control={
                  <Checkbox
                  checked={IsContractEmp}
                  onChange={(e) => setIsContractEmp(e.target.checked)}
                  name="isContractEmployee"
                  color="primary"
                  />
                  }
                 label="Contract Employee"
                  />
                 </FormControl>
                 </Grid>
                </Grid>
                <Button type="submit" variant="contained" color="primary" size="small" sx={{ boxShadow: 1 }} fullWidth>
                  Save
                </Button>
              </Stack>
            </form>
          </Container>
        </Dialog>
      </Grid>

      {/* confirmation dialog */}
      <Dialog
        open={openDelete}
        onClose={handleCloseDelete}
        aria-labelledby="responsive-dialog-title"
        fullScreen={fullScreen}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="responsive-dialog-title">Are you sure you want to delete?</DialogTitle>
        <DialogActions>
          <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
            Cancel
          </Button>
          <Button variant="contained" onClick={() => handleDeleteConfirmed(IdToDelete)} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>
    </>
  );
};

export default UserMst;
